import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VoltaCommon } from '@core/common/volta-common';
import { ThemeModeButtonComponent } from "../../../../shared/components/buttons/theme-mode-button/theme-mode-button.component";
import { MiddleSingleContainerComponent } from "../../../../shared/components/layouts/middle-single-container/middle-single-container.component";
import { ForgotPasswordComponent } from "../../components/forgot-password/forgot-password.component";
import { LoginFormComponent } from "../../components/login-form/login-form.component";

@Component({
    selector: 'app-login',
    imports: [MiddleSingleContainerComponent, ThemeModeButtonComponent, LoginFormComponent, ForgotPasswordComponent],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit{

    route = inject(ActivatedRoute)
    private router = inject(Router);

    VoltaCommon = VoltaCommon;
    redirect = signal<string|undefined>(undefined);
    
    ngOnInit(): void {
        this.redirect.set(this.route.snapshot.queryParams['redirect']);
    }

    onLogin(){
        if(this.redirect()){
            this.router.navigateByUrl(this.redirect() as string)   
        }
        else{
            this.router.navigate(['./'], {
                onSameUrlNavigation: 'reload'
            })
        }
    }
}
